import { render } from "./Shields.vue?vue&type=template&id=3d073bf5&lang=html"
import script from "./Shields.vue?vue&type=script&lang=js"
export * from "./Shields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__